import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../core/services/data.service';
import { Subject } from 'rxjs';
import { ConstantsService } from '../../../core/services/constants.service';
import { filter, tap, map, takeUntil } from 'rxjs/operators';
import  {isNil} from 'lodash-es';
import { TradeSimulation } from '../../../core/models/TradeSimulation';

@Component({
  selector: 'app-simulation-summary-modal',
  templateUrl: './simulation-summary-modal.component.html',
  styleUrls: ['./simulation-summary-modal.component.scss'],
  standalone: false
})
export class SimulationSummaryModalComponent implements OnInit, OnDestroy {
  @Input()
  modelID: string;

  @Input()
  entityName: string;

  dataError: string = null;
  modelPopupMode: any;
  tradeSimulation: TradeSimulation;
  public unsubscribe: Subject<void> = new Subject();

  constructor(
    private dataService: DataService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private constantsService: ConstantsService) {
  }

  ngOnInit() {
    this.modelPopupMode = this.constantsService.modelPopupMode;
    this.dataService.getEntityTrades(this.entityName).pipe(
      map(x => x.entityTrades),
      tap((trades: TradeSimulation[]) => {
        if (isNil(trades) || (trades.length === 0)) {
          this.dataError = `cannot fetch trades for entity [ ${this.entityName} ]`;
        }
      }),
      filter((trades: TradeSimulation[]) => !isNil(trades) && trades.length > 0),
      map((trades: TradeSimulation[]) => {
        for (const t of trades) {
          if (t.modelId === this.modelID) {
            return t;
          }
        }
        this.dataError = `cannot find trade simulation info for model [ ${this.modelID} ] and entity [ ${this.entityName} ]`;
        return null;
      }),
      filter(simu => !isNil(simu)),
    ).pipe(takeUntil(this.unsubscribe)).subscribe(
      result => this.tradeSimulation = result,
      error => console.log('Error happened while getting tradeSimulation:', error));
  }

  ngOnDestroy() {
    this.unsubscribe.next();
  }



}
